function info() {
  let element = document.getElementById('product-information')
  element.scrollIntoView({ behavior: 'smooth' })
}

function features() {
  let element = document.getElementById('features')
  element.scrollIntoView({ behavior: 'smooth' })
}

function specifications() {
  let element = document.getElementById('specifications')
  element.scrollIntoView({ behavior: 'smooth' })
}

function faq() {
  let element = document.getElementById('faq')
  element.scrollIntoView({ behavior: 'smooth' })
}

function support() {
  let element = document.getElementById('support')
  element.scrollIntoView({ behavior: 'smooth' })
}

function reviews() {
  let element = document.getElementById('reviews')
  element.scrollIntoView({ behavior: 'smooth' })
}

function shopNow() {
  const shop = document.getElementById('shopNow')
  // shop.scrollIntoView(true)
}

function one() {
  let t = document.querySelector('.onee-bg')
  t.classList.add('hov')
}
function oneOut() {
  let t = document.querySelector('.onee-bg')
  t.classList.remove('hov')
}

function two() {
  let t = document.querySelector('.twoo-bg')
  t.classList.add('hov')
}
function twoOut() {
  let t = document.querySelector('.twoo-bg')
  t.classList.remove('hov')
}

function three() {
  let t = document.querySelector('.three-bg')
  t.classList.add('hov')
}
function threeOut() {
  let t = document.querySelector('.three-bg')
  t.classList.remove('hov')
}

//product banner animations

// function init() {
let tl = gsap.timeline()
tl.from('.product-hero-section', {
  scale: 0.6,
  autoAlpha: 0,
  duration: 2,
  opacity: 0,
  ease: Expo.easeOut,
  delay: 0.2,
}).to(
  '.reveal',
  {
    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
    y: 0,
    stagger: 0.3,
    duration: 1,
  },
  '-=2.9'
)
// }

// window.addEventListener('load', function (event) {
//   init()
// })

//hover anime
function zoomOnee() {
  let t = document.querySelector('.onee-col')
  t.classList.add('hov')
}

function outOnee() {
  let t = document.querySelector('.onee-col')
  t.classList.remove('hov')
}

function zoomTwoo() {
  let t = document.querySelector('.twoo-col')
  t.classList.add('hov')
}

function outTwoo() {
  let t = document.querySelector('.twoo-col')
  t.classList.remove('hov')
}

function zoomThreee() {
  let t = document.querySelector('.threee-col')
  t.classList.add('hov')
}

function outThreee() {
  let t = document.querySelector('.threee-col')
  t.classList.remove('hov')
}

// stories slider
document.addEventListener('DOMContentLoaded', function () {
  let splide = new Splide('.stories-slider', {
    type: 'loop',
    perPage: 3,
    perMove: 1,
  })

  splide.mount()
})

$('.hover-home-section.owl-carousel').owlCarousel({
  loop: false,
  dots: true,
  margin: 10,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
      nav: false,
      dots: true,
    },
    600: {
      items: 3,
      nav: false,
    },
    1000: {
      items: 3,
      nav: true,
      loop: false,
    },
  },
})

$('.prod-category-mobile.owl-carousel').owlCarousel({
  loop: false,
  margin: 0,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
      nav: false,
    },
    600: {
      items: 2,
      nav: false,
    },
    1300: {
      items: 3,
      nav: false,
      loop: false,
    },
  },
})

$('.product-cat-desk.owl-theme.owl-carousel').owlCarousel({
  loop: false,
  margin: 10,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
      nav: false,
    },
    778: {
      items: 2,
      nav: false,
    },
    1200: {
      items: 3,
      nav: false,
      loop: false,
    },
  },
})

// secondary header active menu

// Cache selectors
var lastId,
  topMenu = $('#secondary-header'),
  topMenuHeight = topMenu.outerHeight() + 1,
  // All list items
  menuItems = topMenu.find('a'),
  // Anchors corresponding to menu items
  scrollItems = menuItems.map(function () {
    var item = $($(this).attr('href'))
    if (item.length) {
      return item
    }
  })

// Bind click handler to menu items
// so we can get a fancy scroll animation
menuItems.click(function (e) {
  var href = $(this).attr('href'),
    offsetTop = href === '#' ? 0 : $(href).offset().top - topMenuHeight + 1
  $('html, body').stop().animate(
    {
      scrollTop: offsetTop,
    },
    850
  )
  e.preventDefault()
})

// Bind to scroll
$(window).scroll(function () {
  // Get container scroll position
  var fromTop = $(this).scrollTop() + topMenuHeight

  // Get id of current scroll item
  var cur = scrollItems.map(function () {
    if ($(this).offset().top < fromTop) return this
  })

  // Get the id of the current element
  cur = cur[cur.length - 1]
  var id = cur && cur.length ? cur[0].id : ''

  $('#secondary-header ul li.' + id + '-div a').focus()

  if (lastId !== id) {
    lastId = id
    $('#secondary-header ul li').removeClass('active')
    $('#secondary-header ul li.' + id + '-div').addClass('active')
  }
})

$(window).scroll(function () {
  var scroll = $(window).scrollTop()

  if (scroll >= 300) {
    $('.secondary-header').removeClass('hdden')
  } else {
    $('.secondary-header').addClass('hdden')
  }
})

var formEnds = $('.launching-soon').offset().top

$(window).scroll(function () {
  if ($(window).scrollTop() >= formEnds) {
    $('.product-sticky').addClass('bottom-to-top')
  } else {
    $('.product-sticky').removeClass('bottom-to-top')
  }
})
